import styled from 'styled-components';

export const StyledResourceOptionWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    width: 24px;
    height: 24px;
  }
`;
